import { render, staticRenderFns } from "./AbkMessagesBox.vue?vue&type=template&id=7e29951a&scoped=true&"
import script from "./AbkMessagesBox.vue?vue&type=script&lang=js&"
export * from "./AbkMessagesBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkMessagesBox.vue?vue&type=style&index=0&id=7e29951a&scoped=true&lang=scss&"
import style1 from "./AbkMessagesBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e29951a",
  null
  
)

export default component.exports